<ion-card class="tarjeta-gestion">
  <ion-card-header>
    <div class="header-gestion">
      <div class="header-fila-principal">
        <div class="titulo-seccion">
          <div class="titulo-con-informacion">
            <ion-card-title>{{ titulo }}</ion-card-title>
            <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
              aria-label="Información">
              <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </div>
          <ion-card-subtitle>{{ subtituloDinamico }}</ion-card-subtitle>
        </div>
      </div>
      <div class="filtros-header">
        <div class="buscador-container">
          <ion-searchbar [(ngModel)]="terminoBusqueda" placeholder="Buscar..." (ionInput)="buscar()"
            (ionClear)="limpiarBusqueda()" debounce="700" class="buscador">
          </ion-searchbar>
        </div>
        <div class="filtro-estado-plan-container">
          <ion-select [(ngModel)]="idEstadoPlanSeleccionado" (ionChange)="onFiltroEstadoPlanChange($event)"
            interface="popover" placeholder="Todos los estados" class="select-filtro-estado-plan"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium select-popover-estado-plan-negocio' }">
            <ion-select-option [value]="null" class="select-opt-pn-todos">Todos los estados</ion-select-option>
            <ion-select-option *ngFor="let e of estadosPlanNegocio" [value]="e.id_estado_plan_negocio"
              [class]="claseOptPopoverEstadoPlan(e.id_estado_plan_negocio)">
              {{ etiquetaOpcionEstadoPlan(e) }}
            </ion-select-option>
          </ion-select>
        </div>
      </div>
    </div>
  </ion-card-header>

  <ion-card-content>
    <div class="loading-container" *ngIf="cargando">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando...</p>
    </div>

    <!-- Vista desktop: tabla -->
    <div class="tabla-container vista-desktop" *ngIf="!cargando">
      <table class="tabla-gestion">
        <thead>
          <tr>
            <th *ngFor="let col of columnasOrdenables" class="th-sortable" (click)="onSortColumn(col.id)"
              [attr.aria-sort]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'ascending' : 'descending') : null"
              [attr.title]="'Ordenar por ' + col.label">
              <span class="th-sortable-content">
                <span class="th-sortable-label">{{ col.label }}</span>
                <span class="th-sort-icon" [class.activo]="isColumnaOrdenActiva(col.sortKey)" aria-hidden="true">
                  <ion-icon
                    [name]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'arrow-up' : 'arrow-down') : 'swap-vertical-outline'">
                  </ion-icon>
                </span>
              </span>
            </th>
            <th class="col-header-acciones">
              <span class="texto-header-acciones">Acciones</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index" class="fila-item">
            <td class="col-productor">
              <div class="productor-celda">
                <button
                  type="button"
                  class="avatar-btn"
                  [class.avatar-btn--con-avance]="getAvanceTotal(item) !== null"
                  [style.--avance-total]="getAvanceTotal(item) ?? 0"
                  [attr.aria-label]="getTextoAvance(item)"
                  (click)="abrirPopoverAvance($event, item)">
                  <svg *ngIf="getAvanceTotal(item) !== null" class="avatar-ring" viewBox="0 0 36 36" aria-hidden="true">
                    <circle class="avatar-ring__track" cx="18" cy="18" r="16"></circle>
                    <circle
                      *ngIf="getAvanceTotal(item) === 100"
                      class="avatar-ring__progress avatar-ring__progress--cerrado"
                      cx="18"
                      cy="18"
                      r="16">
                    </circle>
                    <circle
                      *ngIf="getAvanceTotal(item) !== 100"
                      class="avatar-ring__progress"
                      cx="18"
                      cy="18"
                      r="16"
                      [attr.stroke-dasharray]="longitudAnilloAvatar"
                      [attr.stroke-dashoffset]="longitudAnilloAvatar * (1 - (getAvanceTotal(item) ?? 0) / 100)">
                    </circle>
                  </svg>
                  <span class="avatar" aria-hidden="true">{{ getIniciales(item) }}</span>
                </button>
                <span
                  class="nombre-productor nombre-productor--enlace"
                  role="link"
                  tabindex="0"
                  [attr.aria-label]="'Abrir caracterización de ' + getNombreCompleto(item)"
                  (click)="irACaracterizacion($event, item)"
                  (keydown.enter)="irACaracterizacion($event, item)"
                  (keydown.space)="$event.preventDefault(); irACaracterizacion($event, item)">{{ getNombreCompleto(item) }}</span>
              </div>
            </td>
            <td class="col-unidad">{{ item.unidad_operativa || '-' }}</td>
            <td class="col-unidad">{{ item.area || '-' }}</td>
            <td class="col-comuna">{{ item.comuna || '-' }}</td>
            <td class="col-ultima-visita">{{ formatearFecha(item.ultima_visita) }}</td>
            <td class="col-ultimo-mb" width="5%">{{ item.ultimo_mb || '-'}}</td>
            <td class="col-ultimo-ev" width="5%">{{ item.ultimo_ev || '-'}}</td>
            <td class="col-diag-activo" width="5%">{{ item.tiene_encuesta_activa ? 'Si' : 'No'}}</td>

            <td class="col-estado-plan">
                <span class="badge-estado-plan" [ngClass]="getClaseEstadoPlanNegocioDeItem(item)">{{
                getEstadoPlan(item) }}</span>   
            </td>
            <td class="col-acciones">
              <ion-button fill="clear" size="small" class="btn-acciones"
                (click)="abrirMenuAcciones($event, item)">
                <ion-icon slot="icon-only" name="ellipsis-horizontal-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="6" class="sin-datos">
              <ion-icon name="briefcase-outline"></ion-icon>
              <p>No se encontraron registros para los filtros seleccionados.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Vista móvil: tarjetas -->
    <div class="lista-mobile vista-mobile" *ngIf="!cargando">
      <div class="sin-datos-mobile" *ngIf="items.length === 0">
        <ion-icon name="briefcase-outline"></ion-icon>
        <p>No se encontraron registros para los filtros seleccionados.</p>
      </div>
      <div class="item-card" *ngFor="let item of items; let i = index">
        <div class="item-card-header">
          <div class="item-card-usuario">
            <button
              type="button"
              class="avatar-btn"
              [class.avatar-btn--con-avance]="getAvanceTotal(item) !== null"
              [style.--avance-total]="getAvanceTotal(item) ?? 0"
              [attr.aria-label]="getTextoAvance(item)"
              (click)="abrirPopoverAvance($event, item)">
              <svg *ngIf="getAvanceTotal(item) !== null" class="avatar-ring" viewBox="0 0 36 36" aria-hidden="true">
                <circle class="avatar-ring__track" cx="18" cy="18" r="16"></circle>
                <circle
                  *ngIf="getAvanceTotal(item) === 100"
                  class="avatar-ring__progress avatar-ring__progress--cerrado"
                  cx="18"
                  cy="18"
                  r="16">
                </circle>
                <circle
                  *ngIf="getAvanceTotal(item) !== 100"
                  class="avatar-ring__progress"
                  cx="18"
                  cy="18"
                  r="16"
                  [attr.stroke-dasharray]="longitudAnilloAvatar"
                  [attr.stroke-dashoffset]="longitudAnilloAvatar * (1 - (getAvanceTotal(item) ?? 0) / 100)">
                </circle>
              </svg>
              <span class="avatar" aria-hidden="true">{{ getIniciales(item) }}</span>
            </button>
            <span
              class="nombre-productor nombre-productor--enlace"
              role="link"
              tabindex="0"
              [attr.aria-label]="'Abrir caracterización de ' + getNombreCompleto(item)"
              (click)="irACaracterizacion($event, item)"
              (keydown.enter)="irACaracterizacion($event, item)"
              (keydown.space)="$event.preventDefault(); irACaracterizacion($event, item)">{{ getNombreCompleto(item) }}</span>
          </div>
          <span class="badge-estado-plan" [ngClass]="getClaseEstadoPlanNegocioDeItem(item)">{{
            getEstadoPlan(item) }}</span>
        </div>
        <div class="item-card-body">
          <div class="item-info-row">
            <ion-icon name="business-outline"></ion-icon>
            <span>{{ item.unidad_operativa || '-' }}</span>
          </div>
          <div class="item-info-row">
            <ion-icon name="location-outline"></ion-icon>
            <span>{{ item.comuna || '-' }}</span>
          </div>
          <div class="item-info-row">
            <ion-icon name="calendar-outline"></ion-icon>
            <span>{{ formatearFecha(item.ultima_visita) }}</span>
          </div>
          <div class="item-info-row">
            <ion-icon name="business-outline"></ion-icon>
            <span>{{ item.ultimo_mb || '-'}}</span>
          </div>
          <div class="item-info-row">
            <ion-icon name="business-outline"></ion-icon>
            <span>{{ item.ultimo_ev || '-'}}</span>
          </div>
        </div>
        <div class="item-card-footer">
          <ion-button fill="clear" size="small" class="btn-acciones-mobile"
            (click)="abrirMenuAcciones($event, item)">
            <ion-icon slot="start" name="ellipsis-horizontal-outline"></ion-icon>
            Acciones
          </ion-button>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="paginacion-container" *ngIf="!cargando && items.length > 0">
      <div class="info-paginacion">
        <span>
          Página {{ paginaActual }} de {{ totalPaginas }}
          ({{ totalRegistros }} registro{{ totalRegistros !== 1 ? 's' : '' }})
        </span>
        <div class="selector-tamanio">
          <ion-select [ngModel]="tamanioPagina" (ionChange)="onTamanioPaginaChange($event)" interface="popover"
            class="select-tamanio-pagina" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option *ngFor="let t of opcionesTamanioPagina" [value]="t">
              {{ t }} por página
            </ion-select-option>
          </ion-select>
        </div>
      </div>
      <div class="controles-paginacion">
        <ion-button fill="clear" size="small" [disabled]="paginaActual === 1" (click)="irAPagina(1)">
          <ion-icon slot="icon-only" name="play-skip-back-outline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" [disabled]="paginaActual === 1" (click)="paginaAnterior()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>
        <div class="numeros-pagina">
          <ion-button *ngFor="let p of getPaginasArray()" [fill]="p === paginaActual ? 'solid' : 'clear'"
            [color]="p === paginaActual ? 'primary' : 'medium'" size="small" (click)="irAPagina(p)">
            {{ p }}
          </ion-button>
        </div>
        <ion-button fill="clear" size="small" [disabled]="paginaActual >= totalPaginas" (click)="paginaSiguiente()">
          <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" [disabled]="paginaActual >= totalPaginas"
          (click)="irAPagina(totalPaginas)">
          <ion-icon slot="icon-only" name="play-skip-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-card-content>
</ion-card>

<!-- Popover único de acciones (evita bug de Ionic con triggers en *ngFor) -->
<ion-popover
  [isOpen]="menuAccionesAbierto"
  [event]="menuAccionesEvent"
  (ionPopoverDidDismiss)="cerrarMenuAcciones()"
  dismissOnSelect="true"
  side="start"
  [alignment]="menuAccionesAlignment"
  cssClass="popover-acciones-plan">
  <ng-template>
    <ion-list lines="none" *ngIf="itemMenuActivo">
      <div class="popover-categoria">FICHA DE USUARIO INDAP</div>
      <ion-item button (click)="onAccion('ver_caracterizacion', itemMenuActivo!)">
        <ion-icon slot="start" name="person-outline"></ion-icon>
        <ion-label>Caracterización</ion-label>
      </ion-item>
      <ion-item button (click)="onAccion('margen_bruto', itemMenuActivo!)">
        <ion-icon slot="start" name="trending-up-outline"></ion-icon>
        <ion-label>Margen Bruto</ion-label>
      </ion-item>
      <div class="popover-categoria">PLAN DE NEGOCIO</div>
      <ion-item button (click)="onAccion('diagnostico', itemMenuActivo!)">
        <ion-icon slot="start" name="document-text-outline"></ion-icon>
        <ion-label>Diagnóstico</ion-label>
      </ion-item>
      <ion-item button (click)="onAccion('soluciones', itemMenuActivo!)">
        <ion-icon slot="start" name="bulb-outline"></ion-icon>
        <ion-label>Soluciones</ion-label>
      </ion-item>
      <ion-item button (click)="onAccion('plan_trabajo', itemMenuActivo!)">
        <ion-icon slot="start" name="calendar-outline"></ion-icon>
        <ion-label>Plan de Trabajo</ion-label>
      </ion-item>
      <ion-item button (click)="onAccion('plan_inversion', itemMenuActivo!)">
        <ion-icon slot="start" name="wallet-outline"></ion-icon>
        <ion-label>Plan de Inversión</ion-label>
      </ion-item>
      <div class="popover-categoria">SEGUIMIENTO</div>
      <ion-item button (click)="onAccion('historial_visitas', itemMenuActivo!)">
        <ion-icon slot="start" name="calendar-number-outline"></ion-icon>
        <ion-label>Historial de Visitas</ion-label>
      </ion-item>
      <ion-item button (click)="onAccion('seguimiento_inversion', itemMenuActivo!)">
        <ion-icon slot="start" name="analytics-outline"></ion-icon>
        <ion-label>Seguimiento Inversión</ion-label>
      </ion-item>
      <ion-item *ngIf="false" button (click)="onAccion('supervision_grupal', itemMenuActivo!)">
        <ion-icon slot="start" name="clipboard-outline"></ion-icon>
        <ion-label>Supervisión Grupal</ion-label>
      </ion-item>
      <ion-item *ngIf="false" button (click)="onAccion('supervision_individual', itemMenuActivo!)">
        <ion-icon slot="start" name="clipboard-outline"></ion-icon>
        <ion-label>Supervisión Individual</ion-label>
      </ion-item>

      <ion-item button (click)="onAccion('encuesta_evaluacion', itemMenuActivo!)">
        <ion-icon slot="start" name="star-outline"></ion-icon>
        <ion-label>Encuesta de Evaluación</ion-label>
      </ion-item>
      <ion-item *ngIf="esPlanEnEjecucion(itemMenuActivo) || esPlanCerrado(itemMenuActivo)" button (click)="onAccion('copago', itemMenuActivo!)">
        <ion-icon slot="start" name="checkbox-outline"></ion-icon>
        <ion-label>Copago</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>

<!-- Popover único de avance (evita bug de Ionic con triggers en *ngFor) -->
<ion-popover
  [isOpen]="popoverAvanceAbierto"
  [event]="popoverAvanceEvent"
  (ionPopoverDidDismiss)="cerrarPopoverAvance()"
  side="top"
  alignment="center"
  cssClass="popover-avance-plan">
  <ng-template>
    <div class="popover-avance" *ngIf="itemAvanceActivo">
      <div class="popover-avance__general">
        <div class="popover-avance__general-valor">
          {{ getAvanceTotal(itemAvanceActivo) }}%
        </div>
        <div class="popover-avance__general-etiqueta">Avance general</div>
      </div>
      <div class="popover-avance__seccion">Por etapa</div>
      <ul class="popover-avance__lista">
        <li *ngFor="let r of filasDetalleAvancePopover" class="popover-avance__fila">
          <span class="popover-avance__fila-nombre">{{ r.etiqueta }}</span>
          <span class="popover-avance__fila-valor">{{
            textoPorcentajeDetalle(itemAvanceActivo, r.campo)
          }}</span>
        </li>
      </ul>
    </div>
  </ng-template>
</ion-popover>

<ion-popover *ngIf="informacion" [trigger]="idUnico" [triggerAction]="'click'" reference="trigger" [side]="'top'"
  [alignment]="'center'">
  <ng-template>
    <div class="popover-informacion">
      <p>{{ informacion }}</p>
    </div>
  </ng-template>
</ion-popover>